module.exports = __webpack_public_path__ + "static/media/add-24px.21a9e848.svg";